export default "__VITE_ASSET__BJnK53tV__"